export default {
  en: {
    WelcomeCallIndexScene: {
      title: 'Welcome calls',
    },
  },
};
